<template>
	<div class="action-wrapper">
		<!-- tabs -->
		<ActionTabs
			v-show="shouldDisplayActionsTabs"
		/>
		<!-- edit tag(s) -->
		<EventTagEdit
			v-if="isEditingSingleEventTag"
			:elapsed="elapsed"
		/>
		<EventTagBulkEdit
			v-else-if="isEditingMultipleEventTags"
		/>
		<EventTagTimeshift
			v-else-if="isEditingTimeshift"
		/>
		<AssignPlayerModal v-else-if="assignPlayerModalVisible" />
		<LatestTagsModal v-else-if="latestTagsModalVisible" />
	</div>
</template>

<script>
import ActionTabs from '@js/analysis/blocks/ActionTabs';
import EventTagEdit from '@js/analysis/components/EventTagEdit/EventTagEdit';
import EventTagBulkEdit from '@js/analysis/components/EventTagEdit/EventTagBulkEdit';
import AssignPlayerModal from '@components/GameControl/ice_hockey/AssignPlayerModal';
import LatestTagsModal from '@components/GameControl/ice_hockey/LatestTagsModal';
import EventTagTimeshift from '@videotools/js/analysis/components/EventTagEdit/EventTagTimeshift';
import { mapGetters } from 'vuex';

export default {
	name:       'ActionsBlock',
	components: {
		EventTagBulkEdit,
		EventTagTimeshift,
		ActionTabs,
		EventTagEdit,
		AssignPlayerModal,
		LatestTagsModal,
	},
	props: {
		elapsed: {
			type:    Number,
			default: 0,
		},
	},
	computed: {
		...mapGetters({
			isEditingSingleEventTag:    'eventTagEdit/isSingleEdit',
			isEditingMultipleEventTags: 'eventTagEdit/isBulkEdit',
			isEditingTimeshift:         'eventTagEdit/isTimeshiftEdit',
			assignPlayerModalVisible:   'scoreboardControl/assignPlayerModalVisible',
			latestTagsModalVisible:     'scoreboardControl/latestTagsModalVisible',
		}),
		shouldDisplayActionsTabs() {
			return !(this.isEditingSingleEventTag || this.isEditingMultipleEventTags || this.isEditingTimeshift || this.assignPlayerModalVisible || this.latestTagsModalVisible);
		},
	},
};
</script>

<style lang="scss" scoped>
.action-wrapper {
	width: 100%;
	height: 100%;
	position: relative;
}
</style>
